import { hostToBrand, DEFAULT_BRAND } from '$lib/brand/registry';
import type { LayoutLoad } from './$types';

// True so prerender emits full HTML for crawlers; production is still static files (no Node at request time).
export const ssr = true;
export const prerender = true;
export const trailingSlash = 'always';

export const load: LayoutLoad = async ({ url, fetch }) => {
    try {
        const brand = hostToBrand(url.host);
        const response = await fetch(`/brands/${brand}/brand.json`, {
            cache: 'no-store'
        });

        if (response.ok) {
            const config = await response.json();
            return { brand, config };
        } else {
            console.warn(
                `Failed to load brand config for ${brand}, falling back to ${DEFAULT_BRAND}`
            );
            // Fallback to default brand
            const fallbackResponse = await fetch(`/brands/${DEFAULT_BRAND}/brand.json`, {
                cache: 'no-store'
            });
            if (fallbackResponse.ok) {
                const config = await fallbackResponse.json();
                return { brand: DEFAULT_BRAND, config };
            }
        }
    } catch (error) {
        console.warn('Error loading brand config:', error);
    }

    // Final fallback - return default brand with minimal config
    return {
        brand: DEFAULT_BRAND,
        config: {
            brand: DEFAULT_BRAND,
            displayName: 'Default Brand',
            primaryColor: '#000000',
            secondaryColor: '#666666',
            logo: '/brands/100xdevelopers.com/images/logo.svg',
            favicon: '/brands/100xdevelopers.com/images/logo.svg',
            productName: 'Default Product',
            productDescription: 'Default description',
            convertkit: { formId: 'default' },
            analytics: { plausibleDomain: 'default.com' },
            links: {
                privacy: '/privacy/',
                terms: '/terms/',
                contact: '/contact/',
                refunds: '/refunds/'
            }
        }
    };
};
